import React from 'react'
import { Icon } from 'semantic-ui-react'

import { KnockOperator } from '../Knock/KnockTypes'
import FilterInput from '../../general/FilterInput'
import { IColumn } from '../Types'
import OperatorFilter from './OperatorFilter'

export interface ITextFilterProps {
  validate?: RegExp
  operators?: KnockOperator[]
  filterOperator?: KnockOperator
  filter?: string
  name?: string
  onChange?: (value: Pick<IColumn, 'filter' | 'filterOperator'>) => void
}

export const TextFilter: React.FC<ITextFilterProps> = props => {
  const { onChange, validate, filter, filterOperator, name } = props

  const operators = props.operators || [KnockOperator.EqualTo, KnockOperator.NotEqualTo, KnockOperator.StringWildcard]

  return (
    <div style={{ display: 'flex' }}>
      <FilterInput
        fluid
        name={name}
        size='mini'
        style={{ margin: 5, flex: 1 }}
        validate={validate}
        onChange={value => onChange && onChange({ filter: value })}
        value={filter}
        icon={!!filter && <Icon name='close' onClick={() => onChange && onChange({ filter: '' })} style={{ pointerEvents: 'auto' }} />}
      />
      <OperatorFilter operators={operators} operator={filterOperator} onChange={onChange} style={{ marginTop: 7, marginBottom: 7 }} />
    </div>
  )
}

export default React.memo(TextFilter)
